import { slaAllapot } from './slaSzamitas.ts';

export interface SlaCsikProps {
  /** A határidő kezdete (a megerősítés ideje), ISO-szöveg. */
  kezdet: string;
  /** Az iroda határideje percben (`sla_perc`). */
  slaPerc: number;
  /** Az aktuális idő ezredmásodpercben; tesztelhetőség és közös óra miatt a hívó adja. */
  nowMs: number;
}

/** Hátralévő idő csík és szöveg; lejárat után arany. */
export default function SlaCsik({ kezdet, slaPerc, nowMs }: SlaCsikProps) {
  const kezdetMs = Date.parse(kezdet);
  if (Number.isNaN(kezdetMs)) throw new RangeError(`Érvénytelen kezdési idő: ${kezdet}`);
  const a = slaAllapot({ kezdetMs, slaPerc, nowMs });
  return (
    <div className={`grid gap-1.5 text-xs ${a.kesik ? 'text-masodlagos' : 'text-szoveg-halk'}`}>
      <span aria-hidden className="block h-1 w-full max-w-35 overflow-hidden rounded-[2px] bg-felulet-2">
        <i className={`block h-full ${a.kesik ? 'bg-masodlagos' : 'bg-kiemelt'}`} style={{ width: `${Math.round(a.eltelt * 100)}%` }} />
      </span>
      <span>{a.szoveg}</span>
    </div>
  );
}
